module.exports = __webpack_public_path__ + "img/rocket.launcher.b82bda20.png";